import type { Element } from "React";
import { FormattedMessage } from "react-intl";
import "./IconOpenBets.scss";
type Props = {
  className?: string;
};

const IconOpenBets = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className="asian-icon"
  >
    <title id="title">
      <FormattedMessage tagName="span" id="bets-slip-open-bets" />
    </title>
    <g fill="#4DA1A9" fillRule="evenodd">
      <path d="M2 4h14v18H2z" />
      <path d="M8 2h14v16h-5V3H8z" />
    </g>
  </svg>
);

export default IconOpenBets;
